import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { IonicModule } from 'ionic-angular';

import { IonVirtualKeyboardComponent } from './ion-virtual-keyboard.component';
import { IonVirtualKeyboardKeyComponent } from './ion-virtual-keyboard-key.component';
import { IonVirtualKeyboardService } from './ion-virtual-keyboard.service';
import { IonVirtualKeyboardPopover } from './ion-virtual-keyboard.popover';

@NgModule({
  declarations: [
    IonVirtualKeyboardComponent,
    IonVirtualKeyboardKeyComponent,
    IonVirtualKeyboardPopover
  ],
  providers: [
    IonVirtualKeyboardService,
  ],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  entryComponents: [
    IonVirtualKeyboardComponent,
  ],
  exports: [
    IonVirtualKeyboardComponent,
    IonVirtualKeyboardKeyComponent,
    IonVirtualKeyboardPopover
  ]
})

export class IonVirtualKeyboardModule { }



// WEBPACK FOOTER //
// ./src/modules/utils/ion-virtual-keyboard/ion-virtual-keyboard.module.ts